import React, { Component } from 'react';
import PurchasedItem from './PurchasedItem';
import { AuthContext } from "./../../context/auth";
import {ApiBaseUrl} from '../../constants';
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class Purchased extends Component{
    static contextType = AuthContext;
    state = {
        data: []
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        trackPromise(
        fetch(ApiBaseUrl+"/consumer/purchased_carts/",
            {
                method: 'GET',
                headers:
                    {
                        "Content-Type": "application/x-www-form-urlencoded",
                        "Authorization": "Bearer "+this.context.token
                    }
            })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        data: result.data
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.props.openSnackbar('Oops, something went wrong.')
                }
            )
        )
    }

    render(){
        return(
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    <div className="row">
                    {this.state.data.length ?
                        this.state.data.map(cart => (<PurchasedItem key={cart.cart_id} cart={cart}/>)) :
                        <div className="col-12 text-center text-white">
                        No purchased cart deals
                        </div>
                    }
                    </div>
                </div>
            </div>
        )
    }
}

export default withSnackbar(Purchased,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});